import { Button, TextField, Toolbar, Typography } from '@mui/material';
import AddUpdateMeetingDialog from 'app/components/Dialog/AddUpdateMeetingDialog';
import { getUserFullName } from 'app/utils/appHelpers';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setCurrentMeeting } from 'stores/meeting';


function MeetingDataTableToolbar({ pageTitle, data2, setData, afterUpdateFunc, addAfterTable, isManagementPage, setHighlightQuery }) {

  const [searchText, setSearchText] = useState("");
  const [addMeetingDialogStatus, setAddMeetingDialogStatus] = useState(false);
  const dispatch = useDispatch();

  const handleChangeSearchText = (text) => {


    if (text !== "") {
      const filterData = data2.filter(
        (item) =>
          item.unit.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
          item.inst === text ||
          item.id === Number(text) ||
          item.meetingNo === Number(text) ||
          getUserFullName(item.user).toLocaleLowerCase().includes(text.toLocaleLowerCase())

      );

      setSearchText(text);
      setHighlightQuery(text);
      setData(filterData);

    } else {
      setSearchText(text);
      setHighlightQuery(text);
      setData(data2);
    }
  };


  const handleAddButtonClick = async () => {
    dispatch(setCurrentMeeting({}))
    setAddMeetingDialogStatus(true)
  }



  return (
    <Toolbar className="table-header row" sx={{ justifyContent: 'space-between' }}>
      <div className="title">
        <Typography variant="title">{pageTitle}</Typography>
      </div>

      <div>

        {
          isManagementPage && <Button variant="contained" sx={{ marginTop: '14px', marginRight: '10px' }} size="medium" onClick={
            () => handleAddButtonClick()
          }>Toplantı Ekle</Button>

        }

        <TextField
          id="searchText1xe"
          value={searchText}
          onChange={(e) => handleChangeSearchText(e.target.value)}
          margin="dense"
          label={"Arama Yap"}
          className="mr-4"
          // autoFocus
          style={{ width: "400px", background: 'white' }}
          placeholder={'Bilgi'}
        />
      </div>
      <AddUpdateMeetingDialog open={addMeetingDialogStatus} onClose={() => setAddMeetingDialogStatus(false)} afterUpdateFunc={afterUpdateFunc} addAfterTable={addAfterTable} />
    </Toolbar>
  );
}

export default MeetingDataTableToolbar